import type { ChatSession } from '../services/chatService';

/**
 * Route picker (spec rev 2 §4.5): Trailhead sessions open in the Trailhead viewer,
 * regular chats in the regular chat. Used by the card body, card CTA, and table row
 * so every nav site agrees — kills the previously hardcoded `/chat/persona/...` link
 * that would misroute Trailhead cards.
 */
export function sessionRoute(
  session: Pick<ChatSession, 'id' | 'persona_id' | 'is_trailhead'>,
): string {
  if (!session.persona_id) return '/chat/sessions';
  const base = session.is_trailhead ? 'trailhead' : 'chat';
  return `/${base}/persona/${session.persona_id}/${session.id}`;
}
